import buttonStyle from "./style.css";

export default function ButtonGeneric({onClick = () =>{}, inputType, children,classType }) {
  return (
    <button className={`${buttonStyle} ${classType}`} type={inputType} onClick={onClick}>
      {children}
    </button>
  );
}
